import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { SYSTEM_VERSION } from "../../../core/config/changelog";
import {
  getVisibleUpdates,
  markUpdatesAsSeen,
  resolveUserId,
} from "../../../core/config/updatesNotification";

const Atualizacoes = () => {
  const { acessoAtivo, perfilAtivo } = useSelector((state) => state.access);
  const userId = resolveUserId(perfilAtivo);

  const atualizacoesFiltradas = getVisibleUpdates({ perfilAtivo, acessoAtivo });

  useEffect(() => {
    markUpdatesAsSeen(userId, SYSTEM_VERSION);
  }, [userId]);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* HEADER */}
        <div className="page-header">
          <div className="page-title">
            <h4>Atualizações do Sistema</h4>
            <h6>Histórico oficial de evoluções e melhorias</h6>
          </div>
        </div>

        {/* CARD PRINCIPAL */}
        <div className="card">
          <div className="card-body">
            {atualizacoesFiltradas.length === 0 && (
              <div className="text-center text-muted p-4">
                Nenhuma atualização disponível para seu perfil.
              </div>
            )}

            {atualizacoesFiltradas.map((item, index) => (
              <div key={index} className="update-item">
                {/* Linha versão + data + perfis */}
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <div>
                    <strong className="me-2">{item.versao}</strong>
                    <span className="text-muted">{item.data}</span>
                  </div>

                  <div className="mt-2 mt-md-0">
                    {item.perfis.map((perfil, i) => (
                      <span key={i} className="badge badge-linesecondary ms-1">
                        {perfil}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Título */}
                <div className="fw-semibold mb-2">{item.titulo}</div>

                {/* Lista */}
                <ul className="mb-0 ps-3">
                  {item.itens.map((detalhe, i) => (
                    <li key={i} className="text-muted mb-1">
                      {detalhe}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Atualizacoes;
